var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 15,
    viewBox: "0 0 50 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6387 0.5V14.5H10.082L3.99121 5.68848H3.88867V14.5H0.928711V0.5H3.52637L9.56934 9.30469H9.69238V0.5H12.6387Z",
    fill: "#7E8DB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0842 14.5V0.5H24.5178V2.94043H18.0442V6.27637H24.0325V8.7168H18.0442V12.0596H24.5452V14.5H15.0842Z",
    fill: "#7E8DB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8711 14.5V0.5H36.1406V2.94043H29.8311V6.27637H35.5254V8.7168H29.8311V14.5H26.8711Z",
    fill: "#7E8DB9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5984 2.94043V0.5H49.0964V2.94043H44.8103V14.5H41.8845V2.94043H37.5984Z",
    fill: "#7E8DB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeft);
export default __webpack_public_path__ + "static/media/neft.a390a991aee8e636581d901ddafc4be3.svg";
export { ForwardRef as ReactComponent };